import { render, staticRenderFns } from "./EmployeeStatusDetailForm.vue?vue&type=template&id=801f73ea&"
import script from "./EmployeeStatusDetailForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeStatusDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports